import axios from 'axios';
import config from './config';

// Match pos-resturant / cayenne-builder-fe auth pattern:
// - rely on browser cookies (sid) when present
// - include credentials
axios.defaults.withCredentials = true;
axios.defaults.crossDomain = true;
axios.defaults.baseURL = config.apiBaseUrl;

export function getHeader() {
  const headers = {
    'Access-Control-Allow-Credentials': true,
    'Content-Type': 'application/json; charset=utf-8',
    Accept: 'application/json',
  };

  // If running inside Frappe desk context, csrf token may be injected.
  if (typeof window !== 'undefined') {
    // eslint-disable-next-line no-underscore-dangle
    const csrf = window.csrf_token;
    if (csrf && csrf !== '{{ csrf_token }}') {
      headers['X-Frappe-CSRF-Token'] = csrf;
    }
  }

  return headers;
}

export async function apiGet(url, params) {
  const res = await axios.get(url, { params, headers: getHeader() });
  return res.data;
}

export async function apiPost(url, data) {
  const res = await axios.post(url, data, { headers: getHeader() });
  return res.data;
}
